import Vue from "vue";
import Vuex from "vuex";
import auth0 from "auth0-js";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    colorScheme: {
      navigation: {
        font: { normal: "#fafafa", dark: "#657485" },
        background:
          "background: linear-gradient(rgba(149,149,149,0.9), rgba(149,149,149,0.9)), url('" +
          require("@/assets/img/faces/face.1.jpg") +
          "') no-repeat; background-position: 0px 50px;",
        headerBackground: "#f9f2dc",
      },
      toolbar: {
        background: "background-color:#fff;",
        icons: "#464646",
        font: "#464646", // requires --text  ie. white--text
      },
      content: {
        // background:"background: linear-gradient(135deg, #f9f2dc, #c2bdab)",
        //background:"background: url('" + require('@/assets/img/background/ovationStoreBg.jpg') + "') no-repeat;",
      },
      funds: {
        dollars: { accent: "#3cc0c9" },
        gOvations: { base: "#40c1c9", accent: "#e21f4c" },
        sOvations: { base: "#f4e501", accent: "#e0922f" },
      },
      org: {
        switch: "rgba(118,153,212)",
      },
      self: {
        profile: "#40c1c9",
      },
    },
    userIsAuthenticated: false,
    newUserWizardIsComplete: false,
    userProfileIsComplete: false,
    userDataIsComplete: false,
    verifyAuthenticationRedirectLocation: null,
    auth0: new auth0.WebAuth({
      domain: process.env.VUE_APP_AUTH0_CONFIG_DOMAIN,
      clientID: process.env.VUE_APP_AUTH0_CONFIG_CLIENTID,
      redirectUri: process.env.VUE_APP_DOMAINURL + "/auth0callback",
      responseType: process.env.VUE_APP_AUTH0_CONFIG_RESPONSETYPE,
      scope: process.env.VUE_APP_AUTH0_CONFIG_SCOPE,
    }),
    axiosConfig: {
      baseURL: process.env.VUE_APP_SERVICES_URL,
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("id_token")}`,
        AccessToken: localStorage.getItem("access_token"),
      },
    },
    userSelf: null,
    storeLogout: "",
    snackbar: {
      visible: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      message: "",
      messageType: "success",
    },
    contentStatusMessage: {
      heading: "",
      content: "",
      alertType: "error",
      alertVisible: false,
    },
    pendingInvitesCount: 0,
    storeUrl: process.env.VUE_APP_STORE_URL,
    appVersion: "Version: 2023.7.25",
    squareAppId: process.env.VUE_APP_SQUARE_APP_ID,
    squareLocationId: process.env.VUE_APP_SQUARE_LOCATION_ID,
    onlinePaymentApiFees: 3,
  },
  getters: {
    isSuperAdmin: (state) => {
      return ((state.userSelf || {}).roles || []).some(
        (record) => record == "SuperAdmin"
      );
    },
    isOrgAdmin: (state) => {
      return ((state.userSelf || {}).roles || []).some(
        (record) => record == "OrgAdmin"
      );
    },
    isHRManager: (state) => {
      return ((state.userSelf || {}).roles || []).some(
        (record) => record == "HRManager"
      );
    },
    isOrgOwner: (state) => {
      return ((state.userSelf || {}).currentOrg || {}).isOrgOwner;
    },
    isCurrentOrgActive: (state) => {
      return (((state.userSelf || {}).currentOrg || {}).org || {}).isActive;
    },
    isCurrentOrgSet: (state) => {
      return ((state.userSelf || {}).currentOrg || {}).org;
    },
    getCurrentOrgName: (state) => {
      return ((state.userSelf.currentOrg || {}).org || {}).name;
    },
    isCurrentOrgChild: (state) => {
      return (
        (((state.userSelf || {}).currentOrg || {}).org || {}).parentOrgId !=
        null
      );
    },
    userIsAdministrative: (state) => {
      // is this an administrative user or org owner
      return (
        ((state.userSelf || {}).roles || []).some((role) => role == "Admin") ||
        ((state.userSelf || {}).roles || []).some(
          (role) => role == "SuperAdmin"
        ) ||
        ((state.userSelf || {}).roles || []).some((role) => role == "OrgAdmin")
      );
    },
    userIsAdministrativeOrOrgOwner: (state) => {
      // is this an administrative user or org owner
      return (
        ((state.userSelf || {}).roles || []).some((role) => role == "Admin") ||
        ((state.userSelf || {}).roles || []).some(
          (role) => role == "OrgAdmin"
        ) ||
        ((state.userSelf || {}).roles || []).some(
          (role) => role == "SuperAdmin"
        ) ||
        ((state.userSelf || {}).currentOrg || {}).isOrgOwner
      );
    },
    getHeadingForBalanceBlock: (state, getters) => {
      if (
        (getters.isSuperAdmin || getters.isOrgOwner) &&
        !getters.isCurrentOrgChild
      ) {
        return "Distribute, Send and Spend";
      }
      return "Send and Spend";
    },
    getUserFullName: (state) => {
      if (
        state.userSelf &&
        state.userSelf.profile &&
        state.userSelf.profile.firstname &&
        state.userSelf.profile.lastname
      ) {
        return (
          state.userSelf.profile.firstname.toUpperCase() +
          " " +
          state.userSelf.profile.lastname.toUpperCase()
        );
      }
      return "";
    },
    getUserInitials: (state) => {
      if (
        state.userSelf &&
        state.userSelf.profile &&
        state.userSelf.profile.firstname &&
        state.userSelf.profile.lastname
      ) {
        return (
          state.userSelf.profile.firstname.charAt(0).toUpperCase() +
          state.userSelf.profile.lastname.charAt(0).toUpperCase()
        );
      }
      return "";
    },
    getProfileImageUrl: (state) => {
      if (
        state.userSelf &&
        state.userSelf.profile &&
        state.userSelf.profile.avatarlocal
      ) {
        return state.userSelf.profile.avatarlocal;
      }
      return "";
    },
    isProfileImageSet: (state) => {
      if (
        state.userSelf &&
        state.userSelf.profile &&
        state.userSelf.profile.isavatarlocal &&
        state.userSelf.profile.avatarlocal
      ) {
        return true;
      }
      return false;
    },
    getUserIdentifier: (state) => {
      if (state.userSelf && state.userSelf.profile) {
        return state.userSelf.profile.nameidentifier;
      }
      return "";
    },
    getOrgIdentifier: (state) => {
      return ((state.userSelf.currentOrg || {}).org || {}).subdomain;
    },
    getParentOrgIdentifier: (state, getters) => {
      if (getters.isCurrentOrgChild) {
        return (((state.userSelf || {}).currentOrg || {}).org || {})
          .parentOrgId;
      }
      return getters.getOrgIdentifier;
    },
    getOrgZip: (state) => {
      return ((state.userSelf.currentOrg || {}).org || {}).zip;
    },
    getOrgToken: (state) => {
      return ((state.userSelf.currentOrg || {}).org || {}).token || "";
    },
    getOrgList: (state, getters) => {
      var userOrgs = (state.userSelf || {}).orgs || [];
      var result = userOrgs.filter(function (org) {
        return org.subdomain.includes(getters.getOrgIdentifier);
      });
      return result;
    },
    shareSpendOvations: (state) => {
      // In case current-org is sub-org then look into it's parent-org
      var currentOrg = ((state.userSelf || {}).currentOrg || {}).org || {};
      if (currentOrg.parentOrgId == null || currentOrg.parentOrgId === "") {
        return currentOrg.shareSpendOvations; // return from parent-org
      } else {
        // find the parent-org
        var userOrgs = (state.userSelf || {}).orgs || [];
        var parentOrg = userOrgs.filter(function (o) {
          return o.subdomain === currentOrg.parentOrgId;
        });
        if (parentOrg && parentOrg.length > 0)
          return parentOrg[0].shareSpendOvations;
        else return false;
      }
    },
    allowGivingNoOvations: (state) => {
      // In case current-org is sub-org then look into it's parent-org
      var currentOrg = ((state.userSelf || {}).currentOrg || {}).org || {};
      if (currentOrg.parentOrgId == null || currentOrg.parentOrgId === "") {
        return currentOrg.allowGivingNoOvations; // return from parent-org
      } else {
        // find the parent-org
        var userOrgs = (state.userSelf || {}).orgs || [];
        var parentOrg = userOrgs.filter(function (o) {
          return o.subdomain === currentOrg.parentOrgId;
        });
        if (parentOrg && parentOrg.length > 0)
          return parentOrg[0].allowGivingNoOvations;
        else return false;
      }
    },
    enableRichTextInDashboard: (state) => {
      // In case current-org is sub-org then look into it's parent-org
      var currentOrg = ((state.userSelf || {}).currentOrg || {}).org || {};
      if (currentOrg.parentOrgId == null || currentOrg.parentOrgId === "") {
        return currentOrg.enableRichTextInDashboard; // return from parent-org
      } else {
        // find the parent-org
        var userOrgs = (state.userSelf || {}).orgs || [];
        var parentOrg = userOrgs.filter(function (o) {
          return o.subdomain === currentOrg.parentOrgId;
        });
        if (parentOrg && parentOrg.length > 0)
          return parentOrg[0].enableRichTextInDashboard;
        else return false;
      }
    },
    bountyBoardEnabled: (state) => {
      // In case current-org is sub-org then look into it's parent-org
      var currentOrg = ((state.userSelf || {}).currentOrg || {}).org || {};
      if (currentOrg.parentOrgId == null || currentOrg.parentOrgId === "") {
        return currentOrg.enableBounty; // return from parent-org
      } else {
        // find the parent-org
        var userOrgs = (state.userSelf || {}).orgs || [];
        var parentOrg = userOrgs.filter(function (o) {
          return o.subdomain === currentOrg.parentOrgId;
        });
        if (parentOrg && parentOrg.length > 0) return parentOrg[0].enableBounty;
        else return false;
      }
    },
    learnAndEarnEnabled: (state) => {
      // In case current-org is sub-org then look into it's parent-org
      var currentOrg = ((state.userSelf || {}).currentOrg || {}).org || {};
      if (currentOrg.parentOrgId == null || currentOrg.parentOrgId === "") {
        return currentOrg.enableLearnAndEarn; // return from parent-org
      } else {
        // find the parent-org
        var userOrgs = (state.userSelf || {}).orgs || [];
        var parentOrg = userOrgs.filter(function (o) {
          return o.subdomain === currentOrg.parentOrgId;
        });
        if (parentOrg && parentOrg.length > 0)
          return parentOrg[0].enableLearnAndEarn;
        else return false;
      }
    },
  },
  mutations: {
    setuserIsAuthenticated(state, replacement) {
      state.userIsAuthenticated = replacement;
    },
    setNewUserWizardIsComplete(state, replacement) {
      state.newUserWizardIsComplete = replacement;
    },
    setUserProfileIsComplete(state, replacement) {
      state.userProfileIsComplete = replacement;
    },
    setVerifyAuthenticationRedirectLocation(state, replacement) {
      state.verifyAuthenticationRedirectLocation = replacement;
    },
    refreshAxiosConfigHeaderIdentity(state) {
      state.axiosConfig.headers.Authorization = `Bearer ${localStorage.getItem(
        "id_token"
      )}`;
      state.axiosConfig.headers.AccessToken =
        localStorage.getItem("access_token");
    },
    setUserSelf(state, replacement) {
      state.userSelf = replacement;
      /* if (state.userSelf.profile) {
        if (state.userSelf.profile.isavatarlocal) {
          var avatar = state.userSelf.profile.avatar;
          state.userSelf.profile.avatar = state.userSelf.profile.avatarlocal;
          state.userSelf.profile.avatarlocal = avatar;
        } else {
          state.userSelf.profile.avatarlocal = state.userSelf.profile.avatar;
        }
      } */
      state.pendingInvitesCount = (
        (state.userSelf || {}).pendingInvites || []
      ).length;
    },
    // Check if the user profile is complete by verifing the required user information is complete
    refreshUserProfileIsComplete(state) {
      let isSuperAdmin =
        state.userSelf.roles &&
        state.userSelf.roles.some((role) => role == "SuperAdmin");

      // User profile is complete if First Name, Last Name, Phone are set
      let userProfileIsComplete =
        !!((state.userSelf || {}).profile || {}).firstname &&
        !!((state.userSelf || {}).profile || {}).lastname &&
        !!((state.userSelf || {}).profile || {}).phonenumber;

      // Look only for user profile data is complete
      state.userDataIsComplete = userProfileIsComplete;

      // User profile is complete if First Name, Last Name, and user is either in an Org or is a SuperAdmin
      let newUserWizardIsComplete =
        userProfileIsComplete &&
        (!!state.userSelf.currentOrg.org || isSuperAdmin);
      state.newUserWizardIsComplete = newUserWizardIsComplete;

      // For time being untill I figure it out
      userProfileIsComplete = newUserWizardIsComplete;
      state.userProfileIsComplete = userProfileIsComplete;

      // update status message
      if (!userProfileIsComplete) {
        state.contentStatusMessage = {
          heading: "Profile is Not Complete",
          content:
            "You will not be able to navigate away from this wizard until your profile is complete and you accept at-least one org invite.",
          alertType: "error",
          alertVisible: true,
        };
      } else {
        state.contentStatusMessage = {
          alertVisible: false,
        };
      }
    },
    replaceStatusMessage(state, replacementStatusMessage) {
      state.contentStatusMessage = replacementStatusMessage;
    },
    replaceSnackbar(state, replacementSnackbar) {
      var newSnackbar = {
        visible: true,
        y: replacementSnackbar.hasOwnProperty("y")
          ? replacementSnackbar.y
          : "top",
        x: replacementSnackbar.hasOwnProperty("x")
          ? replacementSnackbar.x
          : null,
        mode: replacementSnackbar.hasOwnProperty("mode")
          ? replacementSnackbar.mode
          : "",
        timeout: replacementSnackbar.hasOwnProperty("timeout")
          ? replacementSnackbar.timeout
          : 10000,
        message: replacementSnackbar.hasOwnProperty("message")
          ? replacementSnackbar.message
          : "",
        messageType: replacementSnackbar.hasOwnProperty("messageType")
          ? replacementSnackbar.messageType
          : "success",
      };
      state.snackbar = newSnackbar;
    },
  },
  actions: {
    auth0Login(context) {
      context.state.storeLogout = "";
      context.state.auth0.authorize();
    },
    auth0Logout(context) {
      // No need to update the bearer in global axiosConfig to null because we are redirecting out of the application
      // Clear Access Token and ID Token from local storage
      localStorage.removeItem("access_token");
      localStorage.removeItem("id_token");
      localStorage.removeItem("expires_at");
      this.userProfile = null;
      //context.commit('setuserIsAuthenticated', false);  // looks funny.
      // redirect to auth0 logout to completely log the user out
      context.state.storeLogout = "";
      var logoutUrl =
        process.env.VUE_APP_AUTH0_CONFIG_DOMAINURL +
        "/v2/logout?returnTo=" +
        process.env.VUE_APP_DOMAINURL +
        "/login&client_id=" +
        process.env.VUE_APP_AUTH0_CONFIG_CLIENTID;
      // Logout from store
      /* setTimeout(function () {
        window.location.href = process.env.VUE_APP_STORE_LOGOUT_URL;
      }, 300); */
      // Logout from app
      setTimeout(function () {
        window.location.href = logoutUrl;
      }, 1000);
    },
    auth0HandleAuthentication(context) {
      context.state.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          let expiresAt = JSON.stringify(
            authResult.expiresIn * 1000 + new Date().getTime()
          );
          // save the tokens locally
          localStorage.setItem("access_token", authResult.accessToken);
          localStorage.setItem("id_token", authResult.idToken);
          localStorage.setItem("expires_at", expiresAt);
          //update the bearer in global axiosConfig
          context.commit("refreshAxiosConfigHeaderIdentity");

          // set the user as unauthenticated in the app (for responsive items) as user needs to go through holding/transition page "/verifyauthentication" first to get credentials
          context.commit("setuserIsAuthenticated", false);
          router.replace("dashboard");
        } else if (err) {
          alert("Login failed. Please try again later.");
          router.replace("/login");
        }
      });
    },
    error401Response(context, error) {
      if (error.response.status == 401) {
        alert(
          "Authorization was denied. Likely your session has expired. You will be redirected to login page."
        );
        context.dispatch("auth0Logout");
      }
    },
  },
});
